<template>
  <base-layout :do-skip-header="false">
    <template #main>
      <h1 class='text-3xl md:text-4xl font-bold my-8'>
        TechTalks, presented by The ITAD Association.
      </h1>

      <div class="mx-auto max-w-7xl">

        <!-- <h2 class='text-lg font-bold mt-8 mb-4'>These interactive sessions will be held in <strong>Room 6 on the first floor</strong> and moderated by <strong>Pieter Waasdorp</strong> from <em>SecondaryMarket.news</em></h2> -->

        <div>
          At the www.EuropeanBrokerMeeting.com 2026 in Portugal, <strong>the TechTalks program will be curated and led
            by <a href=" https://www.ascdi.com/ascdi-initiatives/#ethics-and-standards" target="_blank" rel="noopener"
              class="text-red-700">The ITAD Association</a></strong>, bringing together leading voices from across the
          global IT asset disposition, reuse, and circular technology ecosystem.
          <br><br>
          As the industry’s leading association for ITAD professionals, The ITAD Association is shaping this year’s
          TechTalks to deliver <strong>practical insights, best practices, and forward-looking discussions</strong> that
          matter to today’s technology brokers and secondary market leaders. Sessions will focus on real-world
          challenges and opportunities across areas such as <strong>IT asset disposition, circular economy strategies,
            compliance, data security, reverse logistics, and global market trends</strong>.
          <br><br>
          Through this partnership, The ITAD Association is proud to bring its <strong>deep industry expertise, global
            member network, and commitment to advancing professional standards</strong> to the EuropeanBrokerMeeting
          community.
        </div>

        <div v-if="speakers && speakers.length > 0" class="mt-8">
          <!-- Moderator Section -->
          <h3 class="text-xl md:text-2xl font-bold mb-6 text-gray-800 text-center my-10">Moderators</h3>
          <div class="flex flex-wrap justify-center gap-6">

            <div v-for="speaker in getModerator()" :key="speaker.id"
              class="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden group"
              :class="{
                'w-full md:w-[calc(33.333%-20px)]': getModerator.length <= 3,
                'w-full md:w-[calc(50%-20px)] lg:w-[calc(33.333%-20px)]': getModerator.length > 3
              }">
              <div class="p-6">
                <div class="flex items-center space-x-4"
                  @click="speaker.companyId ? navToAttendee(speaker.companyId) : null"
                  :class="{ 'cursor-pointer': speaker.companyId }">
                  <div class="flex-shrink-0">
                    <!-- Profile Picture or Fallback Initials -->
                    <div v-if="speaker.profilePic"
                      class="w-16 h-16 rounded-full overflow-hidden shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <img :src="speaker.profilePic" :alt="`${speaker.name} profile picture`"
                        class="w-full h-full object-cover" />
                    </div>
                    <div v-else
                      class="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg group-hover:scale-110 transition-transform duration-300">
                      {{ speaker.initials }}
                    </div>
                  </div>
                  <div class="flex-1 min-w-0">
                    <h4
                      class="text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors duration-300">
                      {{ speaker.name }}
                    </h4>
                    <p class="text-sm text-gray-600 mt-1 font-medium">
                      {{ speaker.company }}
                    </p>
                    <p class="text-xs text-gray-500 mt-1">
                      {{ speaker.role }}
                    </p>
                  </div>
                </div>

                <p class="text-xs text-justify text-gray-500 mt-3 transition-all duration-300"
                  :class="{ 'line-clamp-2': !isExpanded(speaker.id) }">
                  {{ speaker.description }}
                </p>

                <button v-if="isLongText(speaker)" @click="toggleExpand(speaker.id)"
                  class="text-blue-500 text-xs mt-1 focus:outline-none">
                  {{ isExpanded(speaker.id) ? 'Show less' : 'Read more' }}
                </button>
              </div>
            </div>
          </div>

          <!-- Speaker Section -->
          <div v-if="speakers && speakers.length > 1">
            <!-- We only show this if there are speakers. More than 1 because the first one is the moderator. -->
            <div v-for="(day, index) in days" :key="index">
              <h3 class="text-xl md:text-2xl font-bold mb-6 text-gray-800 text-center my-10">{{ day.title }}</h3>
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div v-for="speaker in getSpeakersByDay(day.id)" :key="speaker.id"
                  class="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden group">
                  <div class="p-6">
                    <div class="flex items-center space-x-4">
                      <div class="flex-shrink-0">
                        <!-- Profile Picture or Fallback Initials -->
                        <div v-if="speaker.profilePic"
                          class="w-16 h-16 rounded-full overflow-hidden shadow-lg group-hover:scale-110 transition-transform duration-300">
                          <img :src="speaker.profilePic" :alt="`${speaker.name} profile picture`"
                            class="w-full h-full object-cover" />
                        </div>
                        <div v-else
                          class="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-2xl font-bold shadow-lg group-hover:scale-110 transition-transform duration-300">
                          {{ speaker.initials }}
                        </div>
                      </div>
                      <div class="flex-1 min-w-0" @click="speaker.companyId ? navToAttendee(speaker.companyId) : null"
                        :class="{ 'cursor-pointer': speaker.companyId }">
                        <h4
                          class="text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors duration-300">
                          {{ speaker.name }}
                        </h4>
                        <p class="text-sm text-gray-600 mt-1 font-medium">
                          {{ speaker.company }}
                        </p>
                        <p class="text-xs text-gray-500 mt-1">
                          {{ speaker.role }}
                        </p>
                        <a v-if="speaker.talkURL" href="#"
                          @click.stop.prevent="downloadGoogleFile(speaker.talkURL, speaker.name)"
                          class="text-xs text-red-500 font-bold">
                          Download Presentation
                        </a>

                        <p class="text-xs text-green-500 font-bold mt-1">Time slot: {{ speaker.start }} - {{ speaker.end
                        }}</p>
                      </div>
                    </div>
                    <p class="text-xs text-justify text-gray-500 mt-3 transition-all duration-300"
                      :class="{ 'line-clamp-2': !isExpanded(speaker.id) }">
                      {{ speaker.description }}
                    </p>

                    <button v-if="isLongText(speaker)" @click="toggleExpand(speaker.id)"
                      class="text-blue-500 text-xs mt-1 focus:outline-none">
                      {{ isExpanded(speaker.id) ? 'Show less' : 'Read more' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="cursor-default bg-white rounded-xl shadow-lg border border-gray-100 mt-12 overflow-hidden">
            <header class="px-6 sm:px-8 pt-8 pb-6 text-center border-b border-gray-100 bg-gradient-to-br from-slate-50 to-white">
              <h3 class="text-xl md:text-2xl font-bold text-gray-900 tracking-tight">Tech Talks schedule</h3>
              <p class="text-sm font-medium text-red-700 mt-2">Thursday, 22 October</p>
            </header>
            <div class="divide-y divide-gray-100" role="list">
              <div
                v-for="(slot, idx) in techTalkSchedule"
                :key="idx"
                :class="[
                  'grid grid-cols-1 sm:grid-cols-[minmax(0,7.75rem)_1fr] gap-2 sm:gap-8 px-6 sm:px-8 py-4 sm:py-5 sm:items-start transition-colors',
                  slot.isBreak
                    ? 'bg-amber-50/60 hover:bg-amber-50/90'
                    : 'hover:bg-slate-50/80'
                ]"
                role="listitem">
                <time
                  :class="[
                    'text-sm font-semibold text-gray-800 tabular-nums sm:border-l-2 sm:pl-4 sm:py-0.5',
                    slot.isBreak ? 'sm:border-amber-600' : 'sm:border-red-700'
                  ]">{{ slot.time }}</time>
                <template v-if="slot.isBreak">
                  <div
                    class="flex w-full min-w-0 flex-col gap-1 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
                    <p class="text-gray-800 text-sm sm:text-base font-medium leading-snug sm:min-w-0 sm:pr-2">{{ slot.title }}</p>
                    <span
                      class="shrink-0 self-start text-xs font-semibold uppercase tracking-wide text-amber-800/80 sm:self-center">Break</span>
                  </div>
                </template>
                <div v-else class="min-w-0">
                  <p class="text-gray-800 text-sm sm:text-base font-medium leading-snug">{{ slot.title }}</p>
                  <p
                    v-if="slot.speakers && slot.speakers.length"
                    class="mt-1 text-xs sm:text-sm text-gray-500 leading-relaxed">
                    <span
                      v-for="(speaker, sIdx) in slot.speakers"
                      :key="sIdx">
                      <span v-if="sIdx > 0" class="text-gray-300"> · </span>
                      <span class="font-medium text-gray-600">{{ speaker.name }}</span>
                      <span v-if="speaker.company" class="text-gray-400"> ({{ speaker.company }})</span>
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <p class="px-6 sm:px-8 py-4 text-xs sm:text-sm text-gray-500 text-center border-t border-gray-100 italic">
              The Tech Talks Schedule is subject to change without prior notice.
            </p>

            <div class="flex items-center justify-center w-full mt-4">
              <a href="https://www.ascdi.com/ascdi-initiatives/#ethics-and-standards" target="_blank"
                rel="noopener noreferrer">
                <img src="https://www.europeanbrokermeeting.com/images/ITADA_Logo.png" alt="ITAD Association"
                  class="w-96 rounded-lg mb-6 mt-4 cursor-pointer">
              </a>
            </div>

          </div>
        </div>
        <div v-else class="mt-8">
          <!-- All rows use 3-column grid -->
          <div class="grid grid-cols-3 gap-6">
            <!-- First row -->
            <div class="invisible"></div> <!-- Hidden first column -->
            <div class="bg-white rounded-xl shadow border border-gray-100 overflow-hidden animate-pulse">
              <div class="p-6">
                <div class="flex items-center space-x-4">
                  <div class="flex-shrink-0">
                    <div class="w-16 h-16 bg-gray-300 rounded-full"></div>
                  </div>
                  <div class="flex-1 min-w-0 space-y-3">
                    <div class="h-4 bg-gray-300 rounded w-3/4"></div>
                    <div class="h-3 bg-gray-300 rounded w-1/2"></div>
                    <div class="h-3 bg-gray-300 rounded w-2/3"></div>
                    <div class="h-3 bg-gray-200 rounded w-1/3"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="invisible"></div> <!-- Hidden third column -->

            <!-- Second row - all 3 columns visible -->
            <div v-for="i in 8" :key="i"
              class="bg-white rounded-xl shadow border border-gray-100 overflow-hidden animate-pulse"
              :style="`animation-delay: ${i * 0.05}s`">
              <div class="p-6">
                <div class="flex items-center space-x-4">
                  <div class="flex-shrink-0">
                    <div class="w-16 h-16 bg-gray-300 rounded-full"></div>
                  </div>
                  <div class="flex-1 min-w-0 space-y-3">
                    <div class="h-4 bg-gray-300 rounded w-3/4"></div>
                    <div class="h-3 bg-gray-300 rounded w-1/2"></div>
                    <div class="h-3 bg-gray-300 rounded w-2/3"></div>
                    <div class="h-3 bg-gray-200 rounded w-1/3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </template>
  </base-layout>
</template>

<script>
import _ from "lodash";
import BaseLayout from "../components/BaseLayout.vue";


export default {
  name: "TechTalk",
  components: {
    BaseLayout,
  },
  data() {
    return {
      mainSponsor: null,
      sponsors: [],
      speakers: this.getCachedSpeakers(),
      expandedSpeakers: {},
      days: [
        // { id: 1, title: 'Tech Talk Sessions for Thursday' },
        // { id: 2, title: 'Tech Talk Sessions for Friday' }
      ],
      techTalkSchedule: [
        { time: "10:00 – 10:10",
         title: "Welcome to ITAD Association Tech Talks",
         speakers: [{ name: "Billy Marion", company: "ITAD Association" }]
        },
        {
          time: "10:10 – 10:55",
          title: "Industry Leaders Panel",
          speakers: [{ name: "John Spagnuolo", company: "IQ Reseller - Moderator" }, { name: "Todd Bone", company: "PyxTech & iFixit" }, { name: "Andreas Fibiger", company: "Inside Systems" },
          ]
        },
        { time: "10:55 – 11:00", title: "Break", isBreak: true },
        { time: "11:00 – 11:30", title: "Automation in ITAD with REMI", speakers: [{ name: "Anirban Ghose", company: "RenewIT" }, { name: "Lucas Way", company: "RenewIT" }] },
        { time: "11:30 - 11:35", title: "Break", isBreak: true },
        { time: "11:35 – 12:05", title: "How AI Will Mess Up Our Intransparent Market – and Other Crazy Ideas for the Future", speakers: [{ name: "Michael Schmelcher", company: "Re:Rebellion" }] },
        { time: "12:05 – 14:00", title: "Lunch break", isBreak: true },
        { time: "14:00 – 14:05", title: "Welcome Back to ITAD Association Tech Talks", speakers: [{ name: "Billy Marion", company: "ITAD Association" }] },
        { time: "14:05 – 14:35", title: "Legislation as a Sales Tool: How to Read Customer Pressure and Turn it Into Revenue", speakers: [{ name: "Victoria D'Arcy", company: "All Things Circular" }] },
        { time: "14:35 – 14:40", title: "Break", isBreak: true },
        { time: "14:40 – 15:10", title: "The Convergence Point: What's Actually Next for ITAD", speakers: [{ name: "Yves Gheeraert", company: "Blancco" }] },
        { time: "15:10 – 15:15", title: "Break", isBreak: true },
        { time: "15:15 – 15:45", title: "XDE Software as a Final Stage in ITAD", speakers: [{ name: "Tomasz Laskowski", company: "Netland" }] },
        { time: "15:45 – 15:50", title: "Break", isBreak: true },
        { time: "15:50 – 16:20", title: "Network Equipment: Why Factory Reset Isn’t Data Erasure", speakers: [{ name: "Adam Burrett", company: "NovaFox" }] },
        { time: "16:20 – 16:25", title: "Break", isBreak: true },
        { time: "16:25 – 16:55", title: "The 5 Questions You Forgot to Ask About How The EU Impacts Your Business (Beer Can Wait)", speakers: [{ name: "Jan Hoogstrate" }] },
        { time: "16:55 – 17:00", title: "Tech Talks Closing", speakers: [{ name: "Billy Marion/Joe Marion - Moderator" }] },
      ]
    };
  },
  async created() {
    const sponsors = await this.$http.get("/api/misc/sponsors").then(res => res.data.payload)
    const sponsorDTOs = _.map(sponsors, sponsor => {
      return _.extend({}, sponsor, {
        logoURL: `${window.location.origin}/images/sponsors/${sponsor.logo}`,
        sponsorType: `${sponsor.type} Sponsor`
      })
    })
    this.mainSponsor = _.find(sponsorDTOs, { type: "main" })
    this.sponsors = _.difference(sponsorDTOs, [this.mainSponsor])
  },
  mounted() {
    this.getSpeakers();
  },
  methods: {
    isExpanded(id) {
      return !!this.expandedSpeakers[id];
    },
    toggleExpand(id) {
      this.$set(this.expandedSpeakers, id, !this.isExpanded(id));
    },
    isLongText(speaker) {
      return speaker?.description?.length > 120;
    },
    toSponsorSite(sponsor) {
      window.open(sponsor.url, "_blank");
    },
    isSubMainSponsor(sponsorType) {
      return sponsorType.includes('submain')
    },
    async getSpeakers() {
      await new Promise(resolve => setTimeout(resolve, 5000));
      const res = await this.$http.get("/api/techtalks/speakers");

      if (res.data && res.data.speakers) {
        this.speakers = res.data.speakers;
        this.saveSpeakersToCache(res.data.speakers); // Save to localStorage
      } else {
        console.error('Unexpected API response structure:', res.data);
      }
    },
    saveSpeakersToCache(speakers) {
      try {
        localStorage.setItem('speakers', JSON.stringify(speakers));
      } catch (error) {
        console.error('Error saving to localStorage:', error);
      }
    },
    getCachedSpeakers() {
      try {
        const cached = localStorage.getItem('speakers');
        return cached ? JSON.parse(cached) : [];
      } catch (error) {
        console.error('Error reading from localStorage:', error);
        return [];
      }
    },
    getModerator() {
      return this.speakers.filter(speaker => speaker.role === "Moderator")
    },
    getSpeakersByDay(day) {
      return this.speakers.filter(speaker => speaker.day === day && speaker.role !== "Moderator");
    },
    navToAttendee(companyId) {
      const url = this.$router.resolve({ name: 'companyDetail', params: { id: companyId } }).href;
      window.open(url, '_blank');
    },
    downloadGoogleFile(url, name) {
      let exportUrl = null;
      let fileId = null;
      let fileType = 'pptx';

      // Handle Google Slides
      if (url.includes('docs.google.com/presentation')) {
        const match = url.match(/\/d\/([^/]+)/);
        if (match) {
          fileId = match[1];
          fileType = url.includes('export/pdf') ? 'pdf' : 'pptx';
          exportUrl = `https://docs.google.com/presentation/d/${fileId}/export/${fileType}`;
        }
      }

      // Handle Google Drive direct files
      else if (url.includes('drive.google.com/file')) {
        const match = url.match(/\/d\/([^/]+)/);
        if (match) {
          fileId = match[1];
          exportUrl = `https://drive.google.com/uc?export=download&id=${fileId}`;
          fileType = 'pdf';
        }
      }

      // Fallback
      else {
        exportUrl = url;
      }

      // Let the browser handle the download
      const link = document.createElement('a');
      link.href = exportUrl;
      link.download = `${name || 'presentation'}.${fileType}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async directDownload(url, name) {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = name || 'presentation';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } catch (err) {
        console.error('Direct download failed:', err);
      }
    }
  }
};
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* Limit to 2 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>